import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { X, Download } from 'react-feather';
import { toast } from 'react-toastify';

import { downloadFile, createFileUrl } from 'utils/appUtils';
import PurchasesService from 'services/PurchasesService';
import TicketVisual from './TicketVisual';
import * as S from './styles';

interface TicketPreviewModalProps {
	isOpen: boolean;
	onClose: () => void;
	ticket: {
		attendeeCode: string;
		attendeeFirstName: string;
		attendeeLastName: string;
		ticketName: string;
		ticketBatch: string;
		ticketPrice: number;
	} | null;
	event: {
		name: string;
		startDate: string;
		customDate: string;
		fullAddress: string;
		locationType: string;
		thumbnail: string;
	} | null;
}

const TicketPreviewModal = ({ isOpen, onClose, ticket, event }: TicketPreviewModalProps) => {
	const [ isDownloadingPdf, setIsDownloadingPdf ] = useState(false);

	useEffect(() => {
		document.body.style.overflow = isOpen ? 'hidden' : 'initial';
		return () => { document.body.style.overflow = 'initial'; };
	}, [isOpen]);

	if (!isOpen || !ticket || !event) return null;

	const downloadPdf = () => {
		setIsDownloadingPdf(true);
		PurchasesService.downloadTicket(ticket.attendeeCode)
			.then(({ data }: any) => downloadFile(createFileUrl(data), 'ingresso'))
			.catch(({ data }: any) => toast(data?.detail || 'Erro ao baixar PDF', { type: toast.TYPE.ERROR }))
			.finally(() => setIsDownloadingPdf(false));
	};

	const modal = (
		<S.Overlay onClick={onClose}>
			<S.ModalContent onClick={(e: React.MouseEvent) => e.stopPropagation()}>
				<S.ModalHeader>
					<S.ModalTitle>Seu Ingresso</S.ModalTitle>
					<S.CloseButton onClick={onClose}>
						<X size={20} />
					</S.CloseButton>
				</S.ModalHeader>

				<S.ScrollArea>
					<TicketVisual ticket={ticket} event={event} />

					<S.ActionsWrapper>
						<S.ActionButton onClick={downloadPdf} disabled={isDownloadingPdf}>
							{isDownloadingPdf ? <S.Spinner /> : <Download size={16} />}
							Baixar PDF
						</S.ActionButton>
					</S.ActionsWrapper>
				</S.ScrollArea>
			</S.ModalContent>
		</S.Overlay>
	);

	return ReactDOM.createPortal(modal, document.body);
};

export default TicketPreviewModal;
